import { render, staticRenderFns } from "./PortalHub.vue?vue&type=template&id=1d9cbf06&scoped=true"
import script from "./PortalHub.vue?vue&type=script&lang=js"
export * from "./PortalHub.vue?vue&type=script&lang=js"
import style0 from "./PortalHub.vue?vue&type=style&index=0&id=1d9cbf06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9cbf06",
  null
  
)

export default component.exports